export default {
  // 工单信息分页查询
  QUERY_WORKORDER_PAGE: '/property/workOrder/page',
  // 确认完工
  CONFIRM_WORKORDER_COMPLETE: '/property/workOrder/assure',
  // 验收通过/不通过
  WORKORDER_CHECK: '/property/workOrder/check',
  // 删除工单信息
  WORKORDER_DELETE: '/property/workOrder/delete',
  // 工单信息详情
  WORKORDER_DETAIL: '/property/workOrder/detail',
  // 工单信息列表-导出
  WORKORDER_EXPORT: '/property/workOrder/export',
  // 保存/确认派单
  WORKORDER_SAVE: '/property/workOrder/save',
  // 查询报修单
  REPAIR_QUERY: '/property/repair/page',
  //报修单详情
  REPAIRORDER_DETAIL: '/property/repair/detail',
};
